// tslint:disable:component-selector
import { Component, OnInit, Input, ChangeDetectionStrategy, HostBinding, ViewEncapsulation } from '@angular/core';

export enum ButtonSize {
  XSmall = 'xsmall',
  Small = 'small',
  Medium = 'medium',
  Large = 'large'
}

export enum ButtonType {
  Default = 'default',
  Flat = 'flat',
  Primary = 'primary',
  Info = 'info',
  Outline = 'outline',
  Text = 'text'
}

export enum ButtonShape {
  Default = 'default',
  Circle = 'circle',
  Rounded = 'rounded',
  Square = 'square'
}

export enum ButtonTheme {
  Dark = 'dark',
  Light = 'light',
  Themed = 'themed'
}

export enum ButtonAlign {
  Left = 'left',
  Center = 'center'
}

@Component({
  selector: `button[app-button], a[app-button]`,
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ButtonComponent implements OnInit {
  @Input()
  buttonSize = ButtonSize.Medium;

  @Input()
  buttonType = ButtonType.Default;

  @Input()
  buttonTheme = ButtonTheme.Dark;

  @Input()
  buttonShape = ButtonShape.Default;

  @Input()
  buttonAlign = ButtonAlign.Center;

  @Input()
  uppercase = true;

  @Input()
  selected = false;

  @Input()
  expanded = false;

  @Input()
  @HostBinding('disabled') disabled: boolean;

  @Input()
  bordered = true;

  constructor() { }

  ngOnInit() {
  }

}
